export const styleDataGridDefault = {
  '& .MuiDataGrid-row': {
    scrollMarginTop: 60,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 'large',
  },
  '& .MuiDataGrid-cell': {
    fontSize: 11,
  },
  '& .MuiDataGrid-columnHeaderTitle, .MuiDataGrid-columnHeaderTitleContainer': {
    fontSize: 11,
    textTransform: 'uppercase',
    whiteSpace: 'normal',
  },
  '& .MuiDataGrid-cell--editable': {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: '5px',
    borderColor: '#a1a1a1',
    cursor: 'pointer',
  },
  '& .MuiDataGrid-cell--editable:hover': {
    borderColor: 'black',
  },
};
